import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		codeTime: 60
	},
	mutations: {
		//设置验证码倒计时还剩多少秒
		SET_CODETIME(state, res) {
			state.codeTime = res
		},
	},
	actions: {
		// 开始倒计时
		codeTime({
			commit,
			state
		}) {
			const copy = state.codeTime;
			const interval = setInterval(() => {
				let codeTime = state.codeTime - 1;
				if (state.codeTime === 0) {
					clearInterval(interval);
					codeTime = copy;
				}
				commit("SET_CODETIME", codeTime);
			}, 1000)
		}
	}
})
